import { render, staticRenderFns } from "./GrupoEconomicoList.vue?vue&type=template&id=27f31b80&scoped=true"
import script from "./GrupoEconomicoList.vue?vue&type=script&lang=js"
export * from "./GrupoEconomicoList.vue?vue&type=script&lang=js"
import style0 from "./GrupoEconomicoList.vue?vue&type=style&index=0&id=27f31b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f31b80",
  null
  
)

export default component.exports